var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetsSail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "currentColor",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.763 14.388 9.96 12.5l3.803-1.888a.441.441 0 0 0 .192-.587l-.383-.783a.425.425 0 0 0-.576-.196L8 11.526l-4.996-2.48a.425.425 0 0 0-.575.196l-.384.783a.442.442 0 0 0 .192.587L6.04 12.5l-3.803 1.888a.442.442 0 0 0-.191.587l.383.783a.424.424 0 0 0 .575.196L8 13.474l4.996 2.48c.212.108.47.02.575-.196l.384-.783a.442.442 0 0 0-.192-.587Zm-7.745-5.9-.147.708c-.071.345.145.679.44.679H9.69c.295 0 .512-.334.44-.68l-.147-.707c1.12-.613 1.875-1.716 1.875-2.988C11.857 3.567 10.13 2 8 2S4.143 3.567 4.143 5.5c0 1.272.756 2.375 1.875 2.988ZM9.5 5.063c.473 0 .857.392.857.875a.867.867 0 0 1-.857.875.867.867 0 0 1-.857-.875c0-.483.384-.875.857-.875Zm-3 0c.473 0 .857.392.857.875a.867.867 0 0 1-.857.875.867.867 0 0 1-.857-.875c0-.483.384-.875.857-.875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsSail);
export default __webpack_public_path__ + "static/media/LetsSail.ce2ed50a92b788fd0e1617a92600f347.svg";
export { ForwardRef as ReactComponent };